import { render, staticRenderFns } from "./JitsiConfidentiallyMeeting.vue?vue&type=template&id=7b453e5c&"
import script from "./JitsiConfidentiallyMeeting.vue?vue&type=script&lang=js&"
export * from "./JitsiConfidentiallyMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b453e5c')) {
      api.createRecord('7b453e5c', component.options)
    } else {
      api.reload('7b453e5c', component.options)
    }
    module.hot.accept("./JitsiConfidentiallyMeeting.vue?vue&type=template&id=7b453e5c&", function () {
      api.rerender('7b453e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Meeting/JitsiConfidentiallyMeeting.vue"
export default component.exports